import { createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset";
import MerchantDefinedFieldsTable from "./_components/merchant-defined-fields-table";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/merchant-defined-fields/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ContainerInset
      title="Merchant Defined Fields"
      description={
        <>
          Merchant Defined Fields can be passed using the API, Invoicing or
          Virtual Terminal. The Virtual Terminal will display the name of the
          field as labeled below. Definitions are also used in reports.
          <br /> When passing these fields through the API connection, please
          reference the variable names as merchant_defined_field_1,
          merchant_defined_field_2, etc.
        </>
      }
      breadcrumbs={[
        {
          title: "Merchant Defined Fields",
          href: "",
        },
      ]}
    >
      <MerchantDefinedFieldsTable />
    </ContainerInset>
  );
}
